import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const SitePermissionsPageLoader: LoadableType<Omit<unknown, 'flags'>> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsSitePermissionsPage" */ '../src/components/SitePermissions/SitePermissionsPage.tsx'
			)
		).SitePermissionsPage,
});
